const text = `
Pour les remarques ou suggestions, c'est par <a href="mailto:adresse@mail.com">ici</a>.<br />
Pour en savoir plus sur mon travail, visitez <a href="https://www.studionanana.com">mon site internet</a> et ma <a href="https://www.instagram.com/studio.nanana/">page Instagram</a>.
`;

const title = 'RÉSEAUX';

export default { text, title };
